import { isEmpty } from 'lodash';
import { useContext } from 'react';
import { Menu } from '@shared/components/Menu';
import { View } from '@shared/components/View';
import { MBLoadingIndicator } from '@shared/components/loading';
import { MBTextOverlineBold } from '@shared/components/typography';
import { RelatedCardComponent } from '@shared/scenes/workflows/config';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { AddMenu } from './AddMenu';
import { List } from './List';
import { LinkableWorkflow } from './RelatedCardLinkingOptions';
import { SortRow } from './SortRow';
import { useRelatedCardSort } from './useRelatedCardSort';

interface Props {
  workflow: LinkableWorkflow;
  component: RelatedCardComponent;
  loading: boolean;
}

export function RelatedCardSortView({ workflow, component, loading }: Props) {
  const { onAdd, onUpdate, onDelete, selected, available } = useRelatedCardSort(
    workflow?.components,
    component,
  );
  const colors = useContext(ColorThemeContext);

  if (loading) {
    return <MBLoadingIndicator />;
  }

  const hasSort = !isEmpty(component?.listDefault?.sortByComponents);

  return (
    <View padding={2}>
      <MBTextOverlineBold color={colors.foregroundInactive} style={{ paddingLeft: grid(1) }}>
        {i18n('builder.relatedCardOptions.sortBy')}
      </MBTextOverlineBold>
      {!hasSort && (
        <View paddingTop={2}>
          <List options={available} onSelect={option => onAdd(option)} />
        </View>
      )}
      {hasSort && (
        <>
          {selected.map(option => {
            return (
              <SortRow
                key={option.uuid}
                sort={option}
                availableSorts={available}
                onUpdate={onUpdate}
                onDelete={onDelete}
              />
            );
          })}
          <Menu.Separator />
          <AddMenu title={i18n('workflowTemplate.sortBy')} onAdd={onAdd} options={available} />
        </>
      )}
    </View>
  );
}
